// src/components/aiinsight/EditableFooterBlock.jsx
// Branding footer block for AI Insight report canvas.
// Controlled via the ReportBrandingPanel floating editor.
// No longer supports inline editing; strictly reactive to config state.

import React from 'react';
import { Box, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { useTenantExportBranding } from '../../hooks/useTenantExportBranding';
import { useTimezoneFormatter } from '../../hooks/useTimezoneFormatter';
import BRAND from '../../config/branding';

// Expanded default footer config
export const DEFAULT_FOOTER_CONFIG = {
    showFooter: true,
    showDate: true,
    showCompanyName: true,
    customText: '',
    showPoweredBy: true,
    paddingTop: 3,
    paddingBottom: 0,
    paddingHorizontal: 0,
    showDivider: true,
    dividerStyle: 'solid',
    dividerColor: '#e2e8f0',
    align: 'center',
};

const EditableFooterBlock = ({
    config = DEFAULT_FOOTER_CONFIG,
    sx = {},
}) => {
    const { portalName } = useTenantExportBranding();
    const { formatDate } = useTimezoneFormatter();

    if (!config.showFooter) return null;

    const today = formatDate(dayjs(), { year: 'numeric', month: 'long', day: 'numeric' });
    const alignMap = { left: 'flex-start', center: 'center', right: 'flex-end' };
    const justifyContent = alignMap[config.align] || 'center';

    return (
        <Box
            id="report-footer-block"
            sx={{
                width: '100%',
                mt: 4,
                pt: config.paddingTop ?? 3,
                pb: config.paddingBottom ?? 0,
                px: config.paddingHorizontal ?? 0,
                borderTop: config.showDivider
                    ? `1px ${config.dividerStyle || 'solid'} ${config.dividerColor || '#e2e8f0'}`
                    : 'none',
                position: 'relative',
                ...sx,
            }}
        >
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent,
                gap: 0.75,
                flexWrap: 'wrap',
            }}>
                {config.showPoweredBy && (
                    <>
                        {/* <img
                            src="/favicon-32x32.png"
                            alt=""
                            style={{ width: 14, height: 14, filter: 'grayscale(100%) opacity(0.5)' }}
                        /> */}
                        <Typography sx={{ fontSize: 10.5, color: '#cbd5e1' }}>
                            Generated by {BRAND.name}
                        </Typography>
                    </>
                )}
                {config.showPoweredBy && (config.showDate || config.customText) && (
                    <Typography sx={{ fontSize: 10.5, color: '#e2e8f0' }}>·</Typography>
                )}
                {config.showDate && (
                    <Typography sx={{ fontSize: 10.5, color: '#cbd5e1' }}>
                        {today}
                    </Typography>
                )}
                {(config.showDate || config.showPoweredBy) && config.customText && (
                    <Typography sx={{ fontSize: 10.5, color: '#e2e8f0' }}>·</Typography>
                )}
                {config.customText && (
                    <Typography sx={{ fontSize: 10.5, color: '#cbd5e1' }}>
                        {config.customText}
                    </Typography>
                )}
            </Box>
        </Box>
    );
};

export default EditableFooterBlock;
